import { Check, Copy } from 'lucide-react'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'

/** Tiny always-visible copy button for a table cell value — copies without triggering the row's
 *  open-detail click (stopPropagation), flashes a check on success. Shared by the My Drivers and
 *  Driver Verifications tables. The shared hook owns the confirmation timer (cleared on unmount)
 *  and surfaces a refused clipboard as an error instead of a false checkmark. */
export const CellCopy = ({ value, label }: { value: string; label: string }) => {
    const { copiedKey, copy } = useCopyToClipboard()
    return (
        <button
            type="button"
            aria-label={`Copy ${label}`}
            title={`Copy ${label}`}
            onClick={(e) => {
                e.stopPropagation()
                void copy(value)
            }}
            className="shrink-0 rounded-md p-1 text-foreground-muted/70 transition-colors hover:bg-accent-soft hover:text-accent"
        >
            {copiedKey ? <Check size={15} className="text-success" /> : <Copy size={15} />}
        </button>
    )
}
